(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const $ = selector => root.querySelector(selector);
    const form = $('form');
    const storageKey = 'oraguli-custom-selection';
    $('[data-request-success], [data-request-errors]')?.focus();
    if ($('[data-request-success]')) {
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      const confirmation = $('[data-request-success-link]');
      if (confirmation) location.replace(confirmation.href);
      return;
    }
    if (!form || !$('[data-request-submit]')) return;
    const labels = JSON.parse($('[data-gallery-labels]').textContent);
    const multiLabels = JSON.parse($('[data-request-labels]').textContent);
    const dialog = $('[data-gallery]');
    const multi = $('[data-multiple-dialog]');
    const multiOpen = $('[data-open-multiple]');
    const search = $('[data-design-search]');
    const category = $('[data-design-category]');
    const grid = $('[data-gallery-grid]');
    $('[data-gallery-more]')?.remove();
    const resultsPane = grid.parentElement;
    const galleryBody = resultsPane.parentElement;
    let scrollFrame = 0;
    const phone = $('[data-whatsapp]');
    const mainSize = $('[data-primary-size]');
    const sizes = ['6s','12s','16s','18s','20s'];
    let catalogue, loading, selected, pending, saved, results = [], shown = 24, lastCard;
    let primaryQuantity = 1, additional = [], rows = [], galleryIndex, galleryReturn = multiOpen;
    try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
    if (!saved || typeof saved !== 'object' || Array.isArray(saved)) saved = null;
    const text = (key, values) => Object.entries(values).reduce((s,[k,v])=>s.replace(`{${k}}`,v),labels[key]);
    const multiText = (key, values = {}) => Object.entries(values).reduce((s,[k,v])=>s.replaceAll(`{${k}}`,v),multiLabels[key]);
    const asset = file => new URL(file, new URL(root.dataset.catalogUrl, location.href)).href;
    const hasDistinctTitle = design => design.title.replace(/[\s_-]/g,'').toLowerCase() !== design.code.replace(/[\s_-]/g,'').toLowerCase();
    const chosenSize = () => mainSize.value;
    const byCode = code => catalogue?.designs.find(design => design.code === code);
    const validQuantity = value => Number.isInteger(value) && value >= 1 && value <= 99;
    const allCases = () => [{code:selected?.code, size:chosenSize(), quantity:primaryQuantity}, ...additional];
    const total = () => allCases().reduce((sum, row) => sum + row.quantity, 0);
    function notice(selector, value) {const element=$(selector); element.textContent=value; element.hidden=!value;}
    function saveDraft() {
      if (!catalogue) return;
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({version:3, code:selected?.code, size:chosenSize(), quantity:primaryQuantity, additional,
          channel:form.querySelector('[name="contact[preferred_contact]"]:checked')?.value, phone:phone.value,
          name:form.querySelector('[name="contact[name]"]').value, email:form.querySelector('[name="contact[email]"]').value,
          notes:$('[data-request-notes]').value}));
      } catch (_) {}
    }
    function serialize() {
      const cases = allCases().filter(row => row.code && row.size);
      const lines = cases.map((row,index) => {
        const design=byCode(row.code);
        const name=hasDistinctTitle(design) ? `${design.code} — ${design.title}` : design.code;
        return `${index+1}. ${name}\nCase size: ${row.size}\nQuantity: ${row.quantity}\nDesign image: ${asset(design.image)}`;
      });
      const notes=$('[data-request-notes]').value.trim();
      $('[data-request-body]').value=[multiText('body_heading'),...lines,`Total cases: ${cases.reduce((sum,row)=>sum+row.quantity,0)}`,...(notes?[`${multiText('body_notes')}:\n${notes}`]:[])].join('\n\n');
      $('[data-case-count]').value=cases.reduce((sum,row)=>sum+row.quantity,0);
    }
    function contactState() {
      phone.required = form.querySelector('[name="contact[preferred_contact]"]:checked')?.value === 'WhatsApp';
      phone.disabled = !phone.required;
      $('[data-whatsapp-field]').hidden = !phone.required;
      const digits = phone.value.replace(/\D/g,'');
      const invalid = phone.value.trim() && (!/^\+[\d\s().-]+$/.test(phone.value.trim()) || digits.length < 7 || digits.length > 15);
      phone.setCustomValidity(phone.required && invalid ? phone.dataset.invalidPhone : '');
    }
    function updateSummary() {
      const list=$('[data-case-summary]'); list.replaceChildren();
      const cases=allCases().filter(row=>byCode(row.code)&&sizes.includes(row.size));
      for (const row of cases) {
        const li=document.createElement('li'); const design=byCode(row.code);
        const image=document.createElement('img'); image.src=asset(design.thumbnail); image.alt=''; image.width=56; image.height=56; image.loading='lazy';
        const detail=document.createElement('div'); const name=document.createElement('p'); name.textContent=hasDistinctTitle(design)?`${design.code} — ${design.title}`:design.code;
        const info=document.createElement('p'); info.textContent=multiText('details',row);
        detail.append(name,info); li.append(image,detail); list.append(li);
      }
      $('[data-empty-selection]').hidden=cases.length>0;
      $('[data-multiple-total-row]').hidden=!cases.length;
      $('[data-multiple-total]').textContent=cases.reduce((sum,row)=>sum+row.quantity,0);
      multiOpen.textContent=multiText(selected?'manage':'open');
      serialize();
    }
    function commit(design) {
      selected=design;
      $('[data-design-value]').value=hasDistinctTitle(design)?`${design.code} — ${design.title}`:design.code;
      $('[data-design-url]').value=asset(design.image);
      notice('[data-case-error]','');
      multiOpen.removeAttribute('aria-invalid');
    }
    function restore() {
      let data=saved, warning=false;
      if (saved?.version===2) {
        const previous=Array.isArray(saved.items)?saved.items:[];
        data={...saved,...(previous[0]||saved.editor||{}),additional:previous.slice(1)};
      }
      if (data) {
        const design=byCode(data.code) || catalogue.designs.find(d=>`${d.code} — ${d.title}`===data.design);
        if (design) commit(design); else if(data.code) warning=true;
        mainSize.value=sizes.includes(data.size)?data.size:'';
        primaryQuantity=validQuantity(Number(data.quantity))?Number(data.quantity):1;
        if (Array.isArray(data.additional)) for(const row of data.additional) {
          if (row && byCode(row.code) && sizes.includes(row.size) && validQuantity(row.quantity)) additional.push({code:row.code,size:row.size,quantity:row.quantity});
          else warning=true;
        }
      }
      if(warning) notice('[data-restore-warning]',multiText('restored_warning'));
      contactState(); updateSummary(); saveDraft();
    }
    async function load() {
      if (catalogue) return true;
      if (loading) return loading;
      $('[data-catalog-status]').textContent=labels.loading;
      loading=(async()=>{
        try {
          const response=await fetch(root.dataset.catalogUrl);
          if(!response.ok) throw Error('Catalogue response');
          const data=await response.json();
          if(!Array.isArray(data.designs)||!Array.isArray(data.categories)||!data.designs.length) throw Error('Empty catalogue');
          const codes=new Set();
          for(const design of data.designs) {
            if(!design.code||!design.title||!design.image||!design.thumbnail||!Array.isArray(design.categories)||codes.has(design.code)) throw Error('Invalid design');
            codes.add(design.code);
          }
          catalogue=data;
          for(const c of data.categories) category.add(new Option(c.name,c.id));
          $('[data-catalog-status]').textContent='';
          $('[data-request-submit]').disabled=false;
          restore(); return true;
        } catch (_) {$('[data-catalog-status]').textContent=labels.error; return false;}
        finally {loading=null;}
      })();
      return loading;
    }
    function renderCases() {
      const list=$('[data-multiple-rows]'); list.replaceChildren();
      rows.forEach((row,index)=>{
        const card=document.createElement('li'); card.className='custom-cases__row'; card.dataset.caseIndex=index;
        const heading=document.createElement('h3'); heading.textContent=multiText('case',{number:index+1});
        const top=document.createElement('div'); top.className='custom-cases__row-heading'; top.append(heading);
        if(index>0) {
          const remove=document.createElement('button'); remove.type='button'; remove.className='custom-cases__text'; remove.textContent=multiText('remove');
          remove.setAttribute('aria-label',multiText('remove_case',{number:index+1}));
          remove.addEventListener('click',()=>{rows.splice(index,1);notice('[data-multiple-error]','');renderCases();const focus=$('[data-multiple-rows]').children[Math.min(index,rows.length-1)];focus.querySelector('button').focus();});
          top.append(remove);
        }
        const controls=document.createElement('div'); controls.className='custom-cases__controls';
        const design=byCode(row.code); const designButton=document.createElement('button'); designButton.type='button'; designButton.className='custom-cases__design';
        designButton.dataset.chooseCase=index;
        const image=document.createElement('img'); image.width=72;image.height=72;image.alt='';image.hidden=!design;
        if(design) image.src=asset(design.thumbnail);
        const caption=document.createElement('span'); caption.textContent=design?(hasDistinctTitle(design)?`${design.code} — ${design.title}`:design.code):multiText('choose');
        const action=document.createElement('small'); action.textContent=design?labels.change:multiText('choose_hint');
        designButton.append(image,caption,action);
        designButton.addEventListener('click',()=>showGallery(index,designButton));
        const sizeLabel=document.createElement('label'); sizeLabel.textContent=multiText('size');
        const size=document.createElement('select'); size.dataset.modalSize=index; size.add(new Option(multiText('choose_size'),''));
        for(const value of sizes) size.add(new Option(value,value));
        size.value=row.size||''; size.setAttribute('aria-label',multiText('size_case',{number:index+1}));
        size.addEventListener('change',()=>{row.size=size.value;size.removeAttribute('aria-invalid');notice('[data-multiple-error]','');});
        sizeLabel.append(size);
        const qtyLabel=document.createElement('label'); qtyLabel.textContent=multiText('quantity');
        const qty=document.createElement('input');qty.type='number';qty.min='1';qty.max='99';qty.step='1';qty.inputMode='numeric';qty.value=row.quantity;qty.dataset.modalQuantity=index;
        qty.setAttribute('aria-label',multiText('quantity_case',{number:index+1}));
        qty.addEventListener('input',()=>{row.quantity=Number(qty.value);qty.removeAttribute('aria-invalid');notice('[data-multiple-error]','');});
        qtyLabel.append(qty);controls.append(designButton,sizeLabel,qtyLabel);card.append(top,controls);list.append(card);
      });
    }
    multiOpen.addEventListener('click',async()=>{
      if(!await load()||!root.isConnected||multi.open) return;
      rows=allCases().map(row=>({...row}));
      notice('[data-multiple-error]',''); renderCases();multi.showModal();
      document.documentElement.classList.add('custom-cases-open');
      $('[data-multiple-title]').focus();
    });
    $('[data-add-another]').addEventListener('click',()=>{
      rows.push({quantity:1});renderCases();notice('[data-multiple-error]','');
      $('[data-multiple-rows]').lastElementChild.querySelector('button').focus();
    });
    $('[data-save-multiple]').addEventListener('click',()=>{
      for(let i=0;i<rows.length;i++) {
        const row=rows[i]; let field;
        if(!byCode(row.code)) field=$(`[data-choose-case="${i}"]`);
        else if(!sizes.includes(row.size)) field=$(`[data-modal-size="${i}"]`);
        else if(!validQuantity(row.quantity)) field=$(`[data-modal-quantity="${i}"]`);
        if(field) {notice('[data-multiple-error]',multiText('invalid',{number:i+1}));field.setAttribute('aria-invalid','true');field.focus();return;}
      }
      const first=rows[0];commit(byCode(first.code));
      mainSize.value=first.size;
      primaryQuantity=first.quantity;additional=rows.slice(1).map(row=>({...row}));
      contactState();updateSummary();saveDraft();multi.close();
      notice('[data-multiple-status]',total()>1?multiText('saved',{total:total()}):'');
    });
    for(const button of root.querySelectorAll('[data-cancel-multiple]')) button.addEventListener('click',()=>multi.close());
    multi.addEventListener('close',()=>{rows=[];document.documentElement.classList.remove('custom-cases-open');multiOpen.focus();});
    multi.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();multi.close();}});
    multi.addEventListener('click',event=>{if(event.target===multi){const r=multi.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)multi.close();}});

    function highlight() {
      for (const card of grid.querySelectorAll('button')) card.setAttribute('aria-pressed',String(card.dataset.code===pending?.code));
    }
    function inspect(design, card) {
      pending = design; lastCard = card;
      $('[data-detail-empty]').hidden = true;
      $('[data-detail-content]').hidden = false;
      const image = $('[data-detail-image]'); image.src = asset(design.image); image.alt = design.title;
      $('[data-detail-title]').textContent = design.title;
      $('[data-detail-code]').textContent = design.code;
      $('[data-detail-code]').hidden = !hasDistinctTitle(design);
      highlight();
      dialog.dataset.inspect = 'true';
      if (matchMedia('(max-width: 740px)').matches) $('[data-gallery-back]').focus();
    }
    function render(append = false) {
      const start = append ? grid.children.length : 0;
      if (!append) grid.replaceChildren();
      const fragment = document.createDocumentFragment();
      for (const design of results.slice(start, shown)) {
        const card = document.createElement('button'); card.type = 'button'; card.className = 'engraving-gallery__card'; card.dataset.code = design.code;
        card.setAttribute('aria-pressed',String(pending?.code===design.code));
        const image = document.createElement('img'); image.src = asset(design.thumbnail); image.alt = ''; image.width = 360; image.height = 360; image.loading = 'lazy';
        const caption = document.createElement('span'); caption.textContent = design.title;
        const code = document.createElement('small'); code.textContent = design.code;
        code.hidden = !hasDistinctTitle(design);
        card.append(image,caption,code); card.addEventListener('click',()=>inspect(design,card)); fragment.append(card);
      }
      grid.append(fragment);
      $('[data-gallery-empty]').hidden = results.length > 0;
      $('[data-gallery-status]').textContent = text('count',{shown:Math.min(shown,results.length),total:results.length});
      scheduleMore();
    }
    function loadNext() {
      if (!dialog.open || shown >= results.length) return;
      shown = Math.min(shown + 24, results.length);
      render(true);
    }
    function scheduleMore() {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;
        if (!root.isConnected || !dialog.open || shown >= results.length || !resultsPane.getClientRects().length) return;
        const bounds = grid.getBoundingClientRect();
        const pane = resultsPane.getBoundingClientRect();
        const body = galleryBody.getBoundingClientRect();
        if (bounds.bottom <= Math.min(pane.bottom, body.bottom) + 240 && bounds.bottom >= body.top) loadNext();
      });
    }
    function filter() {
      const query = search.value.toLocaleLowerCase().trim();
      results = catalogue.designs.filter(d=>(!category.value || d.categories.includes(category.value)) && (!query || `${d.code} ${d.title}`.toLocaleLowerCase().includes(query)));
      shown = 24;
      resultsPane.scrollTop = 0; galleryBody.scrollTop = 0;
      render();
    }
    async function showGallery(index, trigger) {
      if (!await load() || !root.isConnected || dialog.open) return;
      galleryIndex = index; galleryReturn = trigger;
      pending = byCode(rows[index].code);
      delete dialog.dataset.inspect;
      $('[data-detail-content]').hidden = !pending;
      $('[data-detail-empty]').hidden = Boolean(pending);
      if (pending) inspect(pending);
      delete dialog.dataset.inspect;
      filter(); dialog.showModal();
      document.documentElement.classList.add('engraving-gallery-open');
      search.focus();
      scheduleMore();
    }
    search.addEventListener('input',filter);
    category.addEventListener('change',filter);
    $('[data-filter-reset]').addEventListener('click',()=>{search.value='';category.value='';filter();search.focus();});
    resultsPane.addEventListener('scroll',scheduleMore,{passive:true});
    galleryBody.addEventListener('scroll',scheduleMore,{passive:true});
    window.addEventListener('resize',scheduleMore);
    grid.addEventListener('focusin',()=>{
      const index = Array.from(grid.children).indexOf(document.activeElement);
      if (index >= grid.children.length - 6) loadNext();
    });
    $('[data-use-design]').addEventListener('click',()=>{
      if (!pending) return;
      rows[galleryIndex].code=pending.code;renderCases();galleryReturn=$(`[data-choose-case="${galleryIndex}"]`);
      dialog.close();
    });
    $('[data-gallery-back]').addEventListener('click',()=>{delete dialog.dataset.inspect;(lastCard?.isConnected?lastCard:search).focus();scheduleMore();});
    $('[data-gallery-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>{cancelAnimationFrame(scrollFrame);scrollFrame=0;document.documentElement.classList.remove('engraving-gallery-open');galleryReturn?.focus();});
    dialog.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();dialog.close();}});
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    form.addEventListener('change',()=>{contactState();updateSummary();saveDraft();});
    form.addEventListener('input',()=>{contactState();serialize();saveDraft();});
    form.addEventListener('submit',event=>{
      contactState();saveDraft();
      if(multi.open||!catalogue){event.preventDefault();return;}
      if(!selected||!sizes.includes(chosenSize())){event.preventDefault();notice('[data-case-error]',multiText('required'));multiOpen.setAttribute('aria-invalid','true');multiOpen.focus();return;}
      if(!form.reportValidity()){event.preventDefault();return;}
      serialize();
    });
    if(saved) {
      for(const input of form.querySelectorAll('[name="contact[preferred_contact]"]')) input.checked=input.value===(saved.channel||'Email');
      if(typeof saved.phone==='string') phone.value=saved.phone;
      for(const key of ['name','email']) if(typeof saved[key]==='string') form.querySelector(`[name="contact[${key}]"]`).value=saved[key];
      if(typeof saved.notes==='string') $('[data-request-notes]').value=saved.notes;
    }
    contactState();load();
    root.addEventListener('shopify:section:unload',()=>{
      cancelAnimationFrame(scrollFrame);scrollFrame=0;
      window.removeEventListener('resize',scheduleMore);
      resultsPane.removeEventListener('scroll',scheduleMore);
      galleryBody.removeEventListener('scroll',scheduleMore);
      if(dialog.open)dialog.close();if(multi.open)multi.close();
    });
  }
  const mount=scope=>scope.querySelectorAll('[data-custom-order]').forEach(init);
  mount(document);document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
